<umss-dialog-header
  title="New citation"
  [showCloseButton]="true"
  (onClose)="close()"
/>

<div class="dialog-body" [formGroup]="form">
  <umss-vertical-field label="Title">
    <umss-input formControlName="title" />
  </umss-vertical-field>

  <umss-vertical-field label="Issue">
    <umss-textarea formControlName="issue" />
  </umss-vertical-field>

  <umss-vertical-field label="Required steps or training">
    <umss-textarea formControlName="requiredStepOrTraining" />
  </umss-vertical-field>
</div>

<umss-dialog-footer
  primaryButtonLabel="Save"
  secondaryButtonLabel="Cancel"
  secondaryButtonVariant="Secondary"
  [loading]="loading"
  (onPrimaryClick)="save()"
  (onSecondaryClick)="close()"
/>
